import {Link, useMatch, useResolvedPath} from 'react-router-dom';
import styles from './customLink.module.scss';
import classNames from 'classnames/bind';

const CustomLink = ({
  icon,
  name,
  to,
  plain,
  end,
  className,
  compact,
  badgeCount = 0,
  ...props
}) => {
  const resolved = useResolvedPath(to);
  const match = useMatch({
    path: resolved.pathname,
    end: end ?? (to === '' || to === '/'),
  });
  const cx = classNames.bind(styles);

  const badge =
    badgeCount > 0 ? (
      <span className={styles.navBadge} aria-label={`${badgeCount} new`}>
        {badgeCount > 99 ? '99+' : badgeCount}
      </span>
    ) : null;

  return (
    <>
      {!plain && (
        <Link
          to={to}
          className={cx(
            'navLink',
            match ? 'active' : '',
            compact ? 'compact' : '',
            className,
          )}
          {...props}>
          {!!icon && icon}
          <span>{name}</span>
          {badge}
        </Link>
      )}

      {plain && (
        <Link
          to={to}
          className={cx('plain', match ? 'active' : '', className)}
          {...props}>
          {!!icon && icon}
          <span>{name}</span>
        </Link>
      )}
    </>
  );
};

export default CustomLink;
